// Voucher builder: produces the canonical object both signed and shipped over BLE.
import { getDeviceId } from "@/lib/device";

export interface VoucherPayload {
  id: string;
  sender_id: string;
  sender_device_id: string;
  receiver_id: string;
  receiver_device_id?: string | null;
  amount_cents: number;
  currency: string;
  nonce: string;
  note?: string | null;
  expires_at: string; // ISO
  sender_signature: string; // base64
}

const EXPIRY_HOURS = 72;

export function buildVoucher(args: {
  senderId: string;
  receiverId: string;
  amountCents: number;
  currency?: string;
  note?: string | null;
}): Omit<VoucherPayload, "sender_signature"> {
  return {
    id: crypto.randomUUID(),
    sender_id: args.senderId,
    sender_device_id: getDeviceId(),
    receiver_id: args.receiverId,
    receiver_device_id: null,
    amount_cents: args.amountCents,
    currency: (args.currency ?? "USD").toUpperCase(),
    nonce: crypto.randomUUID().replace(/-/g, ""),
    note: args.note ?? null,
    expires_at: new Date(Date.now() + EXPIRY_HOURS * 3600 * 1000).toISOString(),
  };
}
